import styled from "styled-components";

const MultiValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`

export default MultiValueContainer